import { Dispatch } from "redux";
import { GetState } from "../config/store";
import { api } from "../config/api";
import {
    getNotificationsRequest,
    getNotificationsSuccess,
    getNotificationsFailure,
    putReadNotificationRequest,
    putReadNotificationSuccess,
    putReadNotificationFailure
} from "../reducers/notifications";
import { axiosClient } from "../config/axios";
import { catch401 } from "../helpers/actions";

export const getNotifications = (limit?: number) => (dispatch: Dispatch, getState: GetState) => _getNotifications(limit, dispatch, getState);
const _getNotifications = async (limit: number = 5, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getNotificationsRequest });
        const token = getState().auth?.token;
        if (!token) return;

        const response = await axiosClient.get(`${api.notifications}?limit=${limit}`);

        dispatch({
            type: getNotificationsSuccess,
            payload: response?.data.data.notification,
        });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log("error GET NOTIFICATION",error);
        catch401(errorResponse?.code,dispatch);

        console.log(errorResponse?.code);
        dispatch({ type: getNotificationsFailure });
    }
};

export const putReadNotification = (notificationObject: {id: string, read: boolean, deleted: boolean}) => (dispatch: Dispatch, getState: GetState) => _putReadNotification(notificationObject, dispatch, getState);
const _putReadNotification = async (notificationObject: {id: string, read: boolean, deleted: boolean}, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({type: putReadNotificationRequest});
        const token = getState().auth.token;
        if(!token) return;

        const body = JSON.stringify({
            read: notificationObject.read, 
            deleted: notificationObject.deleted
        });

        const response = await axiosClient.put(`${api.notifications}/${notificationObject.id}`, body);

        dispatch({
            type: putReadNotificationSuccess, 
            payload: response?.data.data.notification
        });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({type: putReadNotificationFailure});
    }
}